var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wh100",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.preloader)?_c('site-preloader'):_vm._e()],1),_vm._v(" "),(_vm.loaded)?_c('div',[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1268fe86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 